import { render } from "./QC2AreaRetention.vue?vue&type=template&id=1160bf8e"
import script from "./QC2AreaRetention.vue?vue&type=script&lang=js"
export * from "./QC2AreaRetention.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/QCCharts/QC2AreaRetention.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1160bf8e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1160bf8e', __exports__)) {
    console.log('reload')
    api.reload('1160bf8e', __exports__)
  }
  
  module.hot.accept("./QC2AreaRetention.vue?vue&type=template&id=1160bf8e", () => {
    console.log('re-render')
    api.rerender('1160bf8e', render)
  })

}


export default __exports__